import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AppAppBar from '../AppAppBar';
import Footer from '../Footer';

export default function Privacy({ mode, toggleColorMode }) {
  return (
    <React.Fragment>
      <AppAppBar mode={mode} toggleColorMode={toggleColorMode} />
      <Container 
        component="main" 
        sx={{ 
          mt: { xs: 12, md: 14 }, 
          mb: { xs: 12, md: 14 },
          px: { xs: 2, sm: 3, md: 4 }
        }} 
        maxWidth="lg"
      >
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Datenschutzerklärung
          </Typography>
          <Typography variant="body1" paragraph>
            Stand: November 2025
          </Typography>
          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            1. Datenschutz auf einen Blick
          </Typography>
          <Typography variant="body1" paragraph>
            Wir legen großen Wert auf den Schutz Ihrer persönlichen Daten. Diese Datenschutzerklärung informiert Sie darüber, wie wir Ihre Daten erheben, verarbeiten und nutzen.
          </Typography>
          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            2. Allgemeine Hinweise
          </Typography>
          <Typography variant="body1" paragraph>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen.
          </Typography>
          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            3. Datenerfassung auf unserer Website
          </Typography>
          <Typography variant="body1" paragraph>
            Wir erheben und verarbeiten verschiedene Arten von Daten, wenn Sie unsere Website nutzen. Ein Teil dieser Daten wird automatisch erfasst, andere Daten werden von Ihnen bereitgestellt.
          </Typography>
          {/* Weitere Datenschutzinformationen hier */}
        </Box>
      </Container>
      <Footer />
    </React.Fragment>
  );
}